export default {
      id: "map__pin-bles-usage",
      viewBox: "0 0 66 137",
      url: __webpack_public_path__ + "img/icons.svg#map__pin-bles",
      toString: function () {
        return this.url;
      }
    }